import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

// Admin-only pages (Photo Library, Hidden duplicates): everyone else lands on Albums
export const AdminOnly = ({ children }) => {
  const { user } = useAuth();
  if (!user) return null;
  return user.role === "admin" ? children : <Navigate to="/" replace />;
};
